import React from 'react';
import './BrandLogo.css';
import logoTransparent from '../lanuramainlogo.png';
import logoOnWhite from '../lanuraAIlogo.png';
import logoIcon from '../lanuramainlogoicon.png';

type BrandLogoProps = {
  width?: number;
  height?: number;
  center?: boolean;
  className?: string;
  variant?: 'transparent' | 'white';
  /** When true, show the icon-only logo (e.g. for collapsed navbar). */
  iconOnly?: boolean;
};

const BrandLogo: React.FC<BrandLogoProps> = ({
  width = 160,
  height = 40,
  center = false,
  className,
  variant = 'transparent',
  iconOnly = false,
}) => {
  const src = iconOnly ? logoIcon : variant === 'white' ? logoOnWhite : logoTransparent;
  const size = iconOnly ? { width: height, height } : { width, height };
  return (
    <img
      className={`brand-logo ${center ? 'center' : ''} ${iconOnly ? 'brand-logo-icon' : ''} ${className ?? ''}`.trim()}
      style={size}
      src={src}
      alt="Lanura"
    />
  );
};

export default BrandLogo;
